import { planFragment } from './plan-fragment';

const name = 'subscription';
const fragment = `fragment ${name} on UtilitySubscription {
  partner,
  partnerOrderId,
  providerOrderId,
  status,
  
  details {
    depositText,
    finalStatus,
    fullName,
    nextStepsText,
    providerData,
    providerName,
    serviceAddress,
    serviceStartDate,
    phone,
    userEmail
  }

  plan {
    ...${planFragment.name}
  }
}`;

export const subscriptionFragment = {
  name,
  fragment,
};
